export default [
  {
    path: "/kys-tedarikci/tedarikciler",
    name: "kys-tedarikci-listesi",
    component: () => import("@/views/kys-tedarikci/TedarikciListesi.vue"),
    meta: { public: false, title: "kys_tedarikci.tedarikciler", yetki: { k: [1190502] } },
  },
  {
    path: "/kys-tedarikci/tedarikciler/ekle",
    name: "kys-tedarikci-ekle",
    component: () => import("@/views/kys-tedarikci/TedarikciEkle.vue"),
    meta: { public: false, title: "kys_tedarikci.yeni_tedarikci_ekle", yetki: { k: [1190503] } },
  },
  {
    path: "/kys-tedarikci/tedarikciler/duzelt/:uuid",
    name: "kys-tedarikci-duzelt",
    component: () => import("@/views/kys-tedarikci/TedarikciEkle.vue"),
    meta: { public: false, title: "kys_tedarikci.tedarikci_duzelt", yetki: { k: [1190504] } },
  },
]
